module.exports = __webpack_public_path__ + "static/img/small_logo.b6be6add.png";